<template>
  <div class="personal">
    <div class="personal-left">
      <div class="title">个人资料</div>
      <div class="ibox-content">
        <div>
          <img src="@/assets/images/user.jpg"
               class="ibox-img">
          <!-- <el-upload
            class="ibox-img"
            accept="image/jpg,image/jpeg,image/png"
            :action="action"
            :headers="gettoken()"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="infoForm.data.avatar" :src="infoForm.data.avatar" class="ibox-img">
            <img v-else src="@/assets/images/user.jpg" class="ibox-img" />
          </el-upload> -->
        </div>
        <ul class="list-group">
          <li v-for="item of infoList"
              :key="item.icon">
            <span class="iconfont icon"
                  :class="item.icon"> {{item.title}}</span>
            <p style="float:right">{{item.desc}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div style="width:5px"></div>
    <div class="personal-right">
      <div class="title">基本资料</div>
      <div class="ibox-content">
        <el-tabs v-model="activeName"
                 type="card">
          <el-tab-pane label="基本资料"
                       name="first">
            <div class="tabs-content">
              <el-form :model="infoForm.data"
                       :rules="infoForm.rules"
                       ref="infoForm"
                       :label-width="infoForm.labelWidth"
                       class="demo-ruleForm">
                <el-form-item v-for="item of infoForm.list"
                              :key="item.label"
                              :label="item.label"
                              :prop="item.value">
                  <el-input v-model="infoForm.data[item.value]"
                            style="width:100%;margin-bottom:10px"
                            size="small"
                            disabled
                            :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                            clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="性别："
                              prop="sex">
                  <el-radio-group v-model="infoForm.data.sex">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item>
                  <el-button size="small"
                             class="button submit"
                             :loading="infoForm.loading"
                             @click="submit('infoForm')">
                    <span class="iconfont iconbaocun icon_item">保存</span>
                  </el-button>
                  <el-button size="small"
                             class="button close"
                             @click="close">
                    <span class="iconfont iconguanbi icon_item"> 关闭</span>
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="修改密码"
                       name="second">
            <div class="tabs-content">
              <el-form :model="passForm.data"
                       :rules="passForm.rules"
                       ref="passForm"
                       :label-width="passForm.labelWidth"
                       class="demo-ruleForm">
                <el-form-item v-for="item of passForm.list"
                              :key="item.label"
                              :label="item.label"
                              :prop="item.value">
                  <el-input v-model="passForm.data[item.value]"
                            type="password"
                            :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                            style="width:100%"
                            size="small"
                            clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="small"
                             class="button submit"
                             :loading="passForm.loading"
                             @click="submit('passForm')">
                    <span class="iconfont iconbaocun icon_item"> 保存</span>
                  </el-button>
                  <el-button size="small"
                             class="button close"
                             @click="close">
                    <span class="iconfont iconguanbi icon_item"> 关闭</span>
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { removeTab } from '@/utils/removeTab'
import md5 from 'js-md5'
import { validateEmail } from '@/utils/rules'
import config from '@/api/config'
export default {
  name: 'Personal',
  props: {},
  computed: {
    activeTab: {
      get () { return this.$store.state.tabs.activeTab },
      set (val) { this.$store.commit('updateActiveTab', val) }
    },
    TabList: {
      get () { return this.$store.state.tabs.TabList },
      set (val) { this.$store.commit('updateTabList', val) }
    }
  },
  data () {
    var validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.passForm.data.surePass !== '') {
          this.$refs.passForm.validateField('surePass')
        }
        callback()
      }
    }
    var validateSurePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passForm.data.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      action: config.upload,
      companyName:JSON.parse(localStorage.personal).loginTissueName,
      deptName:JSON.parse(localStorage.personal).deptName,
      employeeName:JSON.parse(localStorage.personal).employeeName,
      infoList: [
        { icon: 'icongeren', title: '账号:', desc: JSON.parse(localStorage.personal).userName },
        { icon: 'iconbumen', title: '昵称:', desc: JSON.parse(localStorage.personal).nickName },
        // { icon: 'icondianhua', title: '手机号码:', desc: JSON.parse(localStorage.personal).phonenumber },
        // { icon: 'iconbumen', title: '所属部门:', desc: '研发部门 / 董事长' },
        // { icon: 'iconyoujian', title: '邮件地址:', desc: 'boyo@xzc.com' },
        { icon: 'iconriqi', title: '创建时间:', desc: JSON.parse(localStorage.personal).createTime }
      ],
      // 个人信息
      infoForm: {
        labelWidth: '18%',
        loading: false,
        data: {
          userId: JSON.parse(localStorage.personal).userId,
          // userName: JSON.parse(localStorage.personal).userName,
          // phonenumber: JSON.parse(localStorage.personal).phonenumber,
          // email:  JSON.parse(localStorage.personal).email,
          sex: '' + JSON.parse(localStorage.personal).sex,
          nickName:JSON.parse(localStorage.personal).nickName,
          avatar:JSON.parse(localStorage.personal).avatar,
        },
        list: [
          // { label: '账号：', value: 'userName' },
          { label: '昵称：', value: 'nickName' },
          // { label: '手机号码：', value: 'phonenumber' },
          // { label: '邮箱：', value: 'email' }
        ],
        rules: {
          nickName: [
            { required: true, message: '请输入用户昵称', trigger: 'blur' },
            { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
          ],
          // email: [
          //   { required: true, validator: validateEmail, trigger: 'blur' }
          // ]
        }
      },
      // 修改密码
      passForm: {
        loading: false,
        labelWidth: '18%',
        data: {
          userId: JSON.parse(localStorage.personal).userId,
          oldPassword: '',
          newPassword: '',
          newPasswordTwo:'',
          // surePass: ''
        },
        list: [
          { label: '旧密码：', value: 'oldPassword' },
          { label: '新密码：', value: 'newPassword' },
          { label: '确认新密码：', value: 'newPasswordTwo' },
          // { label: '确认密码：', value: 'surePass' }
        ],
        rules: {
          oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
          newPassword: [
            { required: true, validator: validateNewPass, trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6到 16 个字符', trigger: 'blur' }
          ],
          newPasswordTwo: [
            { required: true, validator: validateNewPass, trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6到 16 个字符', trigger: 'blur' }
          ],
          surePass: [
            { required: true, validator: validateSurePass, trigger: 'blur' }
          ]
        }
      }
    }
  },
  mounted () {

  },
  methods: {
    submit (form) {
      this.$refs[form].validate((val) => {
        if (val) {
          if (form === 'passForm') {
            // params.oldPassword = md5.hex(params.oldPassword)
            // params.password = md5.hex(params.password)
            // params.surePass = md5.hex(params.surePass)
              const params = JSON.parse(JSON.stringify(this[form].data))
              if(params.newPassword != params.newPasswordTwo){
                  this.$message({ message: '两次密码不一致！', type: 'error' })
                  return
              }
              let oldPass = params.oldPassword
              let newPass = params.newPassword
              params.oldPassword = md5.hex(params.oldPassword)
              params.newPassword = md5.hex(params.newPassword)
              this.$api.user.password(params).then(res => {
                if (res.code === 0) {
                  this.$message({ message: res.msg, type: 'success' })
                  localStorage.clear()
                  localStorage.removeItem("token");
                  // localStorage.removeItem('client')
                  localStorage.removeItem('roleId')
                  localStorage.removeItem('userButtonList')//用户菜单按钮权限
                  this.$store.commit('RouterLoad', false)
                  this.$router.push('/login')
                  this.$store.commit('updateTabList', [])
                  this.$store.commit('updateActiveTab', '')
                } else {
                  params.oldPassword = oldPass
                  params.newPassword = newPass
                  this.$message({ message: res.msg, type: 'error' })
                }
              }, err => {
                console.log(err)
              })
          }else{
            const params = JSON.parse(JSON.stringify(this.infoForm.data))
            
            params.roleIdList=[JSON.parse(localStorage.roleIdList)]
            // console.log(params)
            this.$api.user.changeUserPersonalCenter(params).then(res => {
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                // localStorage.personal = JSON.stringify(res.data)
                // localStorage.personal.loginTissueName = this.companyName
                // localStorage.personal.deptName = this.deptName
                // localStorage.personal.employeeName = this.employeeName
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            }, err => {
              console.log(err)
            })
          }
          // console.log(this[form].data)
          this[form].loading = false
        }
      })
    },
    close () {
      let that = this
      removeTab(this.activeTab, that)
    },
    gettoken(){
        let Token = localStorage.token;
      return { Token: JSON.parse(Token).value }
    },
     beforeAvatarUpload(file) {
      // return new Promise((resolve, reject) => {
      //   let isLt2M2 = file.size / 1024 / 1024 < 0.2 // 判定图片大小是否大于200Kb
      //   if (isLt2M2) {
      //     resolve(file)
      //   }
      //   imageConversion.compressAccurately(file, 200).then(res => {
      //     resolve(res)
      //   })
      // })
    },
    handleAvatarSuccess (res, file, fileList, value) {
      if (res.code === 0) {
          this.infoForm.data.avatar = res.data
      } else {
        this.$message({ message: res.msg, type: 'error' })
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.title
  height 41px
  font-size 14px
  text-align left
  background-color #f0f3f4
  color #333
  border-radius 2px 2px 0 0
  padding 12px
  box-sizing border-box
  border-bottom 1px solid #eee
.ibox-content
  background-color #ffffff
  padding 15px 20px 20px 20px
  border-color #e7eaec
  -webkit-border-image none
  -o-border-image none
  border-image none
  border-style solid
  border-width 1px 0px 0
.ibox-content>>>.el-form-item__error
  top 30%
  right 3%
  left 80%
  text-align right
.ibox-img
  height 120px
  width 120px
  border-radius 50%
  margin: auto
  cursor pointer
.list-group
  margin 20px 0
  border-top 1px solid #e7eaec
  li
    border-bottom 1px solid #e7eaec
.icon
  font-size 14px
.tabs-content
  border-left 1px solid #eee
  border-bottom 1px solid #eee
  padding 10px
.button
  color #fff
  border-radius 3px
.submit
  background #1ab394
  border 1px solid #1ab394
.submit:hover
  background #18a689
.close
  background #ec4758
  border 1px solid #ec4758
.close:hover
  background #c9302c
/deep/ .el-upload
     width: 120px;
     height: 120px;
     line-height: 120px;
</style>



// WEBPACK FOOTER //
// src/views/personal/personal.vue